import type { SvgComponent } from '@/types/react-components';

export const PauseIcon = ({ ...props }: SvgComponent) => (
  <svg viewBox="0 0 10 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M1.26668 0.133301C0.677346 0.133301 0.200012 0.610634 0.200012 1.19997V10.8C0.200012 11.3893 0.677346 11.8666 1.26668 11.8666H2.33335C2.92268 11.8666 3.40001 11.3893 3.40001 10.8V1.19997C3.40001 0.610634 2.92268 0.133301 2.33335 0.133301H1.26668ZM7.66668 0.133301C7.07735 0.133301 6.60001 0.610634 6.60001 1.19997V10.8C6.60001 11.3893 7.07735 11.8666 7.66668 11.8666H8.73335C9.32268 11.8666 9.80001 11.3893 9.80001 10.8V1.19997C9.80001 0.610634 9.32268 0.133301 8.73335 0.133301H7.66668Z"
      fill="black"
    />
  </svg>
);
